export default __webpack_public_path__ + "locales/pt-BR/People.json?hash=a4b7077ffece31cdf774eb097cc6a86c";